__turbopack_context__.v({
  "freeBox__jsFjg": "PlasmicZpusob-module__dOJ-ka__freeBox__jsFjg",
  "freeBox__p1N0F": "PlasmicZpusob-module__dOJ-ka__freeBox__p1N0F",
  "freeBox__pzM7U": "PlasmicZpusob-module__dOJ-ka__freeBox__pzM7U",
  "h1": "PlasmicZpusob-module__dOJ-ka__h1",
  "root": "PlasmicZpusob-module__dOJ-ka__root",
  "slotTargetSlot": "PlasmicZpusob-module__dOJ-ka__slotTargetSlot",
  "slotTargetSlot2": "PlasmicZpusob-module__dOJ-ka__slotTargetSlot2",
  "svg__l1Adt": "PlasmicZpusob-module__dOJ-ka__svg__l1Adt",
});
